const isInterestLikeEntryType = (entryType) => entryType === 'INTEREST' || entryType === 'ACCRUED_INTEREST';

export default isInterestLikeEntryType;
